import { alpha, Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles<Theme>(({ palette, spacing }) => {
  return {
    root: {
      color: "black",
      border: "none",
      "&.MuiDataGrid-autoHeight .MuiDataGrid-row--lastVisible .MuiDataGrid-cell":
        {
          borderBottomColor: palette.grey[100],
        },
      "& .MuiDataGrid-cell": {
        padding: spacing(3),
        "&:focus": {
          outline: "none",
        },
        "&:focus-within": {
          outline: "none",
        },
      },
      "& .MuiDataGrid-columnHeader": {
        padding: spacing(3),
        "&:focus": {
          outline: "none",
        },
        "&:focus-within": {
          outline: "none",
        },
      },
      "& .MuiDataGrid-row": {
        backgroundColor: palette.common.white,
        "&:hover": {
          backgroundColor: palette.common.white,
        },
      },
      "& .MuiDataGrid-columnSeparator": {
        visibility: "visible",
      },
      "& .MuiDataGrid-footerContainer": {
        borderTopColor: "transparent",
      },
    },
    timeRoot: {
      color: alpha(palette.common.black, 0.6),
      fontSize: 13,
    },
    hiddenSeparators: {
      "& .MuiDataGrid-columnSeparator": {
        display: "none",
      },
    },
  };
});

export default useStyles;
